import $ from 'jquery';
import 'velocity-animate';
import 'rangeslider.js';

// for staggered animations, select these individually
let footerLiLogos = $('.footer-logos, .footer-copyright'),
  footerLiLinks = $('.footer-links li'),
  footerLiSocial = $('footer ul:first li'),
  headerLiNav = $('#menu-main-nav li'),
  headerLiAll = $('.top-bar-all-link'),
  headerLiSearch = $('.top-bar-right li:first');

import config from './globals/config';

export default function (
  headerLi,
  footerLi,
  trailersSlicesA,
  logo,
  first,
  firstCont,
  videoCont,
  overlay,
  doneCallback
) {
  if (config.theWindow.width() > 1024 && !config.isNoHover) {

    // safari can't handle transitions, but they make other browsers animate lovely
    // so turn off transitions for safari in css
    // this is done here as homepage animation is only issue
    if ( !/^((?!chrome).)*safari/i.test(navigator.userAgent) ) {
      $('body').addClass('not-safari');
    }

    //animation section
    headerLi.velocity({
      translateY: '-1rem',
    }, {
      duration: 0,
    });

    footerLi.velocity({
      opacity   : 0,
      translateY: '1rem',
    }, {
      duration: 0,
    });

    trailersSlicesA.css({ 'opacity': 0, 'margin-left': '2em' });

    videoCont.velocity({ opacity: 0.33, 'scale': 1.85 });

    logo.velocity({
      opacity: 1,
    }, {
      duration: 1000,
      //delay: 1000,
      complete: function () {
        overlay.velocity({
          opacity: 0,
        }, {
          duration: 1000,
          display : 'none',
          complete: function () {
            first.velocity({ opacity: 1 }, { duration: 0 });

            firstCont.velocity({ left: 0 }, {
              duration: 700,
              delay   : 1000,
              complete: function () {
                setTimeout(function () {
                  trailersSlicesA.velocity('trailers-slices-intro', {
                    stagger : 150,
                    complete: function () {
                      config.isIntroDone = true;
                      doneCallback();
                    },
                  });

                  headerLiNav.velocity('top-bar-intro', { stagger: 150 });

                  setTimeout(function () {
                    headerLiAll.velocity('top-bar-intro');

                    setTimeout(function () {
                      headerLiSearch.velocity('top-bar-intro');
                    }, 150);
                  }, 150 * headerLiNav.length );

                  footerLiLogos.velocity('footer-intro');

                  setTimeout(function () {
                    footerLiLinks.velocity('footer-intro', { stagger: 100 });

                    setTimeout(function () {
                      footerLiSocial.velocity('footer-intro', { stagger: 100 });
                    }, 150 * footerLiLinks.length);
                  }, 150);

                }, 1000);
              },
            });
          },
        });
      },
    });

  } else {

    logo.velocity({
      opacity: 1,
    }, {
      duration: 500,
      delay   : 500,
      complete: function () {
        overlay.velocity({
          opacity: 0,
        }, {
          duration: 3000,
          display : 'none',
        });
      },
    });
  }
}
